import { styled } from "@linaria/react";
const InlineCode = /*#__PURE__*/styled("span")({
  name: "InlineCode",
  class: "i5qaoq3"
});
export default InlineCode;

require("../../.linaria-cache/src/components/InlineCode.linaria.module.css");